import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export default class TasksRequest extends GenericRequest {

    term;
    page;
    task_parent_id;
    task_state_id;
    filter_options;

    constructor(page, term = '', taskParentId = null, taskStateId = 0, filterOptions = {}) {
        super(METHOD_POST, ApiEndpoints.TASKS);

        this.page = page;
        this.term = term;
        this.task_parent_id = taskParentId;
        this.task_state_id = taskStateId;
        this.filter_options = filterOptions;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.task_parent_id ) request.criteria.task_parent_id = this.task_parent_id;
        if ( this.task_state_id && this.task_state_id !== 0 ) request.criteria.task_state_ids = [this.task_state_id];
        if ( this.filter_options && this.filter_options.year && this.filter_options.year !== -1 ) request.criteria.year = this.filter_options.year;
        if ( this.filter_options && this.filter_options.month && this.filter_options.month !== -1 ) request.criteria.month = this.filter_options.month;
        if ( this.filter_options && this.filter_options.company_id ) request.criteria.company_id = this.filter_options.company_id;
        if ( this.filter_options && this.filter_options.construction_id ) request.criteria.construction_id = this.filter_options.construction_id;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/ws/TasksRequest.js